import { render, staticRenderFns } from "./ReservasGenericas.vue?vue&type=template&id=4ef494a2&scoped=true"
import script from "./ReservasGenericas.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservasGenericas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReservasGenericas.vue?vue&type=style&index=0&id=4ef494a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef494a2",
  null
  
)

export default component.exports